import { render } from "./AboutBlock.vue?vue&type=template&id=41ed4d69"
import script from "./AboutBlock.vue?vue&type=script&lang=js"
export * from "./AboutBlock.vue?vue&type=script&lang=js"

import "./AboutBlock.vue?vue&type=style&index=0&id=41ed4d69&lang=css"
script.render = render

export default script